import styled from 'styled-components'
import { theme } from '../../../config';

const Wrapper = styled.div`
  background: ${theme.colors.white};
  box-shadow: 0px 0px 4px rgba(176, 139, 0, 0.1);
  border-radius: 8px;
  height: 100%;
  width: 100%;
  padding: 25px;
`;

const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const DropdownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const IconWrapper = styled.img<{ type: 'hired' | 'failed' }>`
  height: ${({ type }) => type === 'hired' ? '60px' : '50px'};
  width:  ${({ type }) => type === 'hired' ? '70px' : '50px'};;
`;

const DetailsWrapper = styled.div`
  flex-direction: row;
  display: flex;
`;

const RightDetailsWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: row;
`;

const LeftDetailsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  align-items: center;
  color: #595959
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-size: 14px;
  font-family: 'Orkney Medium';
`;

const Count = styled.div`
  font-size: 24px;
  font-family: 'Orkney Medium';
`;

export {
   Wrapper, 
   IconWrapper, 
   InsightsWrapper, 
   DropdownWrapper, 
   DetailsWrapper, 
   RightDetailsWrapper, 
   TextWrapper, 
   Title, 
   Count, 
   LeftDetailsWrapper
}